/**
 * Dayjs Plugin Type Augmentations
 *
 * This file ensures that downstream consumers of @adp-wfn/mdf-core get proper
 * TypeScript support for all dayjs plugins used by LocaleHelper.
 *
 * Without these imports, the generated .d.ts files won't include the plugin
 * type augmentations, causing errors like:
 * "TS2339: Property 'utc' does not exist on type 'typeof dayjs'"
 */

// These imports trigger dayjs module augmentation for each plugin
import 'dayjs/plugin/advancedFormat';
import 'dayjs/plugin/customParseFormat';
import 'dayjs/plugin/dayOfYear';
import 'dayjs/plugin/duration';
import 'dayjs/plugin/isBetween';
import 'dayjs/plugin/isoWeek';
import 'dayjs/plugin/isSameOrAfter';
import 'dayjs/plugin/isSameOrBefore';
import 'dayjs/plugin/localeData';
import 'dayjs/plugin/localizedFormat';
import 'dayjs/plugin/objectSupport';
import 'dayjs/plugin/quarterOfYear';
import 'dayjs/plugin/relativeTime';
import 'dayjs/plugin/timezone';
import 'dayjs/plugin/utc';
import 'dayjs/plugin/weekday';

// Custom MDF plugins with type augmentations
import './core/BusinessDays';

// Export a marker to ensure this file is emitted as a declaration
export const DAYJS_PLUGINS_LOADED = true;
